<div class="title-bar baseline">
  <h1>
    {{ "MERCHANT_APPROVALS.TITLE" | translate }}
  </h1>
</div>

<div class="flex center space-between checkbox-btns-container mb-4 gap-1">
  <div class="flex gap-1">
    <mat-checkbox
      color="primary"
      class="me-4 easy-checkbox"
      (change)="$event ? dataSource.toggleAllRows() : null"
      [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
      [indeterminate]="
        dataSource.selection.hasValue() && !dataSource.isAllSelected()
      "
      [disabled]="!dataSource.data.length"
    >
    </mat-checkbox>
    <div>
      {{ dataSource.selection.selected.length + ("SHARED.PIECES" | translate) }}
      {{ "SHARED.SELECTED" | translate }}
    </div>
  </div>
  <div>
    <button
      class="me-4"
      mat-raised-button
      color="primary"
      [disabled]="dataSource.selection.selected.length > 0 ? null : true"
      (click)="approveItems(true)"
    >
      {{ "SHARED.APPROVE" | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      [disabled]="dataSource.selection.selected.length > 0 ? null : true"
      (click)="approveItems(false)"
    >
      <mat-icon>close</mat-icon>
      {{ "SHARED.DECLINE" | translate }}
    </button>
  </div>
</div>

<div class="table-container">
  <table
    class="data-table"
    mat-table
    [dataSource]="dataSource"
    matSort
    #takeOverTable
  >
    <app-checkable-column
      [hideCheckboxInHeader]="true"
      [tableRef]="takeOverTable"
    >
    </app-checkable-column>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "MERCHANT_APPROVALS.TABLE.COMPANY_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <a
          [routerLink]="[
            '/admin/approvals/merchants/view-merchant',
            element.merchantId,
            'basic-data'
          ]"
          [queryParams]="{
            merchantName: element.companyName,
            siteId: element.siteId
          }"
        >
          {{ element.companyName }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="taxNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "MERCHANT_APPROVALS.TABLE.TAX_NUMBER" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.taxNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="siteName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "MERCHANT_APPROVALS.TABLE.SITE_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <a
          [routerLink]="[
            '/admin/approvals/merchants/view-merchant',
            element.merchantId,
            'sites'
          ]"
          [queryParams]="{
            merchantName: element.companyName,
            siteId: element.siteId
          }"
        >
          {{ element.siteName }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="merchantType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "MERCHANT_APPROVALS.TABLE.ACTIVITY_TYPE" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ "MERCHANT.TYPE." + element.merchantType | translate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="licenseNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "MERCHANT_APPROVALS.TABLE.EXCISE_LICENSE_NUMBER" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.licenseNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex gap-2">
          <button
            [matTooltip]="'SHARED.DECLINE' | translate"
            mat-icon-button
            color="primary"
            class="stroked"
            (click)="approveItems(false, element.id)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <button
            [matTooltip]="'SHARED.APPROVE' | translate"
            mat-icon-button
            color="primary"
            class="filled"
            (click)="approveItems(true, element.id)"
          >
            <mat-icon>checkmark</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="dataSource.displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="
        let row;
        let idx = index;
        columns: dataSource.displayedColumns
      "
    ></tr>
  </table>
</div>
<div *ngIf="dataSource.isLoading | async">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<mat-paginator
  [pageSizeOptions]="dataSource.pageSizeOptions"
  [pageSize]="dataSource.pageSizeOptions[0]"
  showFirstLastButtons
>
</mat-paginator>
